import {
  createContext,
  useCallback,
  useEffect,
  useMemo,
  useState,
} from 'react';
import PropTypes from 'prop-types';

export const ResellerReportContext = createContext();

export const ResellerReportProvider = ({ children }) => {
  const [financialYear, setFinancialYear] = useState('');
  const [financialMonth, setFinancialMonth] = useState('');
  const [searchQuery, setSearchQuery] = useState('');
  const [resellerTableData, setResellerTableData] = useState([]);
  const [resellerTableConfig, setResellerTableConfig] = useState([]);
  const [initialLoad, setInitialLoad] = useState(true);
  const [importError, setImportError] = useState('');


  const updateResellerConfig = useCallback(() => {
    if (!resellerTableData.length > 0) return;
    const result = Object.keys(resellerTableData[0])
      .filter((key) => key !== 'rowConfiguration')
      .map((key, index) => ({
        field: key,
        header: key,
        filter: false,
        visible: true,
        defaultPinned: index + 1 === 1,
        sortable: true,
        order: index + 1,
        menuItems: [
          {
            label: key,
            items: [
              {
                type: 'sort',
                field: key,
                showSortButtonInHeader: true,
                options: [
                  {
                    label: 'Sort Ascending',
                    icon: 'pi pi-arrow-up',
                    order: 1,
                  },
                  {
                    label: 'Sort Descending',
                    icon: 'pi pi-arrow-down',
                    order: -1,
                  },
                ],
                valueType: 'string',
              },
            ],
          },
        ],
      }));
    setResellerTableConfig(result);
  }, [resellerTableData]);

  useEffect(() => {
    updateResellerConfig();
  }, [updateResellerConfig]);

  const value = useMemo(() => {
    return {
      financialYear,
      financialMonth,
      searchQuery,
      setSearchQuery,
      setFinancialMonth,
      setFinancialYear,
      resellerTableData,
      setResellerTableData,
      resellerTableConfig,
      initialLoad,
      setInitialLoad,
      importError,
      setImportError,
    };
  }, [
    financialYear,
    financialMonth,
    searchQuery,
    resellerTableData,
    resellerTableConfig,
    initialLoad,
    importError,
  ]);

  return (
    <ResellerReportContext.Provider value={value}>
      {children}
    </ResellerReportContext.Provider>
  );
};

ResellerReportProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
